import script from "./EcommerceShoppingCart.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceShoppingCart.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceShoppingCart.vue?vue&type=style&index=0&id=55adb28c&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55adb28c"]])

export default __exports__